import { Component } from '@angular/core';

@Component({
  selector: 'app-termsandcond',
  templateUrl: './termsandcond.component.html',
  styleUrl: './termsandcond.component.scss'
})
export class TermsandcondComponent {

}
